import React, { createContext, useEffect, useState } from 'react';
import axios from "axios";

export const StoreContext = createContext(null);

const StoreContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState({});
  const [cartPrices, setCartPrices] = useState({});
  const [additionals, setAdditionals] = useState({});
  const url = process.env.REACT_APP_API_URL || "http://localhost:4000";
  console.log("API URL:", url);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [bev_list, setBevList] = useState([]);
  const [order_list, setOrders] = useState([]);

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });


  const addToCart = async (itemId, size, addOns, price) => {
    if (!cartItems[itemId]) {
      setCartItems((prev) => ({ ...prev, [itemId]: 1 }));
    } else {
      setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
    }
    if (token) {
      await axios.post(url + '/api/cart/add', { itemId, size, userId: token }, { headers: { token } });
    }
  };

  const removeFromCart = async (itemId, size) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));

    if (token) {
      await axios.post(url + "/api/cart/remove", { itemId, userId: token }, { headers: { token } });
    }
  };

  const getTotalCartAmount = () => {
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = bev_list.find((product) => product._id === item);
        if (itemInfo) {
          totalAmount += itemInfo.price * cartItems[item];
        }
      }
    }
    return totalAmount;
  };

  const fetchOrders = async (token) => {
    const response = await axios.get(url + "/api/order/listorders", {}, { headers: { token } });
    setOrders(response.data.data);
  }

  const fetchBevList = async () => {
    const response = await axios.get(url + "/api/beverage/list");
    setBevList(response.data.data);
  };

  const loadCartData = async (token) => {
    const response = await axios.post(url + "/api/cart/get", {}, { headers: { token } });
    setCartItems(response.data.cartData);
    setCartPrices(response.data.cartPrices);
    setAdditionals(response.data.additionals);
  };

  useEffect(() => {
    async function loadData() {
      await fetchBevList();
      await fetchOrders();
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        setToken(storedToken);
        await loadCartData(storedToken);
      }
    }
    loadData();
  }, []);

  const contextValue = {
    bev_list,
    cartItems,
    cartPrices,
    additionals,
    setCartItems,
    setCartPrices,
    setAdditionals,
    addToCart,
    removeFromCart,
    user,
    url,
    token,
    setToken,
    setUser,
    getTotalCartAmount,
  };

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContextProvider;
